exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slogan[data-v-f9c35cfa]{position:relative}.slogan h3[data-v-f9c35cfa]{display:none;color:#000}@media (min-width:1200px){.slogan h3[data-v-f9c35cfa]{display:inline-block;margin-top:450px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9c35cfa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vue/components/header/MainHeader.vue
// module id = oXU5
// module chunks = 0